import { motion } from "framer-motion";
import { useState } from "react";

export default function HeroImage(props) {
  const [imageLoading, setImageLoading] = useState(true);
  const [pulsing, setPulsing] = useState(true);

  const imageLoaded = () => {
    setImageLoading(false);
    setTimeout(() => setPulsing(false), 600);
  };

  return (
    <div
    className={`${pulsing ? "pulse" : ""} loadable`}
    style={{ width: "100%", background: "#000" }}
  >
    <motion.img
      className="background"
      src={props.imageS} 
      srcSet={`${props.imageS} 300w, ${props.imageL} 1280w`}
      initial={{ opacity: 0 }}
      animate={{
        opacity: imageLoading ? 0 : 1
      }}
      transition={
        (
        { opacity: { delay: 0, duration: 0.5 } })
      }
      onLoad={imageLoaded}
      width="100%"
    />
  </div>
  );
};